export class User {
    constructor(public name: string, public phone: string, public email: string, public subject: string, public message: string) {
    }
}
